var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoActiveService(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "31px",
    viewBox: "0 0 28 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / pause") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.5,4.5 L22.23,4.5 C21.6,2.76 19.95,1.5 18,1.5 C16.05,1.5 14.4,2.76 13.77,4.5 L7.5,4.5 C5.85,4.5 4.5,5.85 4.5,7.5 L4.5,28.5 C4.5,30.15 5.85,31.5 7.5,31.5 L28.5,31.5 C30.15,31.5 31.5,30.15 31.5,28.5 L31.5,7.5 C31.5,5.85 30.15,4.5 28.5,4.5 Z M18,4.5 C18.825,4.5 19.5,5.175 19.5,6 C19.5,6.825 18.825,7.5 18,7.5 C17.175,7.5 16.5,6.825 16.5,6 C16.5,5.175 17.175,4.5 18,4.5 Z M19.5,25.5 L12,25.5 C11.175,25.5 10.5,24.825 10.5,24 C10.5,23.175 11.175,22.5 12,22.5 L19.5,22.5 C20.325,22.5 21,23.175 21,24 C21,24.825 20.325,25.5 19.5,25.5 Z M24,19.5 L12,19.5 C11.175,19.5 10.5,18.825 10.5,18 C10.5,17.175 11.175,16.5 12,16.5 L24,16.5 C24.825,16.5 25.5,17.175 25.5,18 C25.5,18.825 24.825,19.5 24,19.5 Z M24,13.5 L12,13.5 C11.175,13.5 10.5,12.825 10.5,12 C10.5,11.175 11.175,10.5 12,10.5 L24,10.5 C24.825,10.5 25.5,11.175 25.5,12 C25.5,12.825 24.825,13.5 24,13.5 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Account-Overview",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03.00.Residential.Account-Overview.No-Active-Services",
    transform: "translate(-647.000000, -314.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(486.000000, 247.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-pause",
    transform: "translate(157.000000, 66.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 36 0 36 36 0 36"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F9A720",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoActiveService);
export default __webpack_public_path__ + "static/media/no-active-service.da4884c6210633a60659aa729e3f1d54.svg";
export { ForwardRef as ReactComponent };